import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Table, Dropdown, Menu } from "antd";
import { BsThreeDots } from "react-icons/bs";
import { CgExport } from "react-icons/cg";
import ExportModal from "../notification/ExportModalNotification";
const NotificationTable = () => {
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Data Sent",
      dataIndex: "datasent",
      key: "datasent",
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let statusClass = "";
        switch (text.toLowerCase()) {
          case "sent":
            statusClass = "status-sent";
            break;
          case "pending":
            statusClass = "status-pending";
            break;
          case "failed":
            statusClass = "status-failed";
            break;
          default:
            statusClass = "status-default";
        }
        return <span className={`status-badge ${statusClass}`}>{text}</span>;
      },
    },
  ];

  const data = [
    {
      key: "1",
      email: "levon@gmail.com",
      subject: "Remainder : 1st Surveillance Audit Due in 15 Days",
      datasent: "12-jan-2025",
      status: "Sent",
    },
    {
      key: "2",
      email: "vardhan@gmail.com",
      subject: "Remainder : 2nd Surveillance Audit Due in 30 Days",
      datasent: "12-sep-2025",
      status: "Pending",
    },
    {
      key: "3",
      email: "syam@gmail.com",
      subject: "Remainder :  certification expiry Due in 60 Days",
      datasent: "12-oct-2025",
      status: "Failed",
    },
    {
      key: "4",
      email: "janu@gmail.com",
      subject: "Remainder : 1st Surveillance Audit Due in 15 Days",
      datasent: "12-feb-2025",
      status: "Sent",
    },
    {
      key: "5",
      email: "garth@gmail.com",
      subject: "Remainder : 2nd Surveillance Audit Due in 30 Days",
      datasent: "12-feb-2024",
      status: "pending",
    },
  ];

  const [isExportVisible, setIsExportVisible] = useState(false);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("All");
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2024-01-01");

  // 👇 State for each switch
  const [firstAudit, setFirstAudit] = useState(false);
  const [secondAudit, setSecondAudit] = useState(false);
  const [certExpiry, setCertExpiry] = useState(false);

  const [firstAuditDays, setFirstAuditDays] = useState(15);
  const [secondAuditDays, setSecondAuditDays] = useState(30);
  const [certExpiryDays, setCertExpiryDays] = useState(60);

  return (
    <>
      <div className="filter-card p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Button className="clear-btn">CLEAR FILTERS</Button>
          <Form.Select className="filter-select w-auto">
            <option>From Beginning</option>
          </Form.Select>
        </div>

        <Form>
          <div className="row g-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Search</Form.Label>
                <Form.Control
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option>All</option>
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From</Form.Label>
                <DatePicker
                  className="form-control"
                  value={dayjs(fromDate)}
                  onChange={(date) => setFromDate(date.format("YYYY-MM-DD"))}
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>

            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To</Form.Label>
                <DatePicker
                  className="form-control"
                  value={dayjs(toDate)}
                  onChange={(date) => setToDate(date.format("YYYY-MM-DD"))}
                  format="YYYY-MM-DD"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row mt-4 ">
            {/* 1st Surveillance */}
            <div className="col-md-4 d-flex align-items-center justify-content-center gap-1">
              <label className="me-2 mb-0 filter-label">
                1st Surveillance Audit
              </label>
              <div className="form-check form-switch">
                <input
                  className={`form-check-input ${
                    firstAudit ? "switch-green" : ""
                  }`}
                  type="checkbox"
                  role="switch"
                  id="firstAuditSwitch"
                  checked={firstAudit}
                  onChange={() => setFirstAudit(!firstAudit)}
                />
              </div>
              <Dropdown
                overlay={
                  <Menu
                    onClick={({ key }) => setFirstAuditDays(Number(key))}
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {Array.from({ length: 60 }, (_, i) => i + 1).map((day) => (
                      <Menu.Item key={day}>
                        {day} {day === 1 ? "Day" : "Days"}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button className="btn-clearfilters">
                  {firstAuditDays} Days
                </Button>
              </Dropdown>
            </div>

            {/* 2nd Surveillance */}
            <div className="col-md-4 d-flex align-items-center gap-1">
              <label className="me-2 mb-0 filter-label">
                2nd Surveillance Audit
              </label>
              <div className="form-check form-switch">
                <input
                  className={`form-check-input ${
                    secondAudit ? "switch-green" : ""
                  }`}
                  type="checkbox"
                  role="switch"
                  id="secondAuditSwitch"
                  checked={secondAudit}
                  onChange={() => setSecondAudit(!secondAudit)}
                />
              </div>
              <Dropdown
                overlay={
                  <Menu
                    onClick={({ key }) => setSecondAuditDays(Number(key))}
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {Array.from({ length: 60 }, (_, i) => i + 1).map((day) => (
                      <Menu.Item key={day}>
                        {day} {day === 1 ? "Day" : "Days"}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button className="btn-clearfilters">
                  {secondAuditDays} Days
                </Button>
              </Dropdown>
            </div>

            {/* Certification Expiry */}
            <div className="col-md-4 d-flex align-items-center gap-1">
              <label className="me-2 mb-0 filter-label">
                Certification Expiry
              </label>
              <div className="form-check form-switch">
                <input
                  className={`form-check-input ${
                    certExpiry ? "switch-green" : ""
                  }`}
                  type="checkbox"
                  role="switch"
                  id="certExpirySwitch"
                  checked={certExpiry}
                  onChange={() => setCertExpiry(!certExpiry)}
                />
              </div>
              <Dropdown
                overlay={
                  <Menu
                    onClick={({ key }) => setCertExpiryDays(Number(key))}
                    style={{ maxHeight: "200px", overflowY: "auto" }}
                  >
                    {Array.from({ length: 60 }, (_, i) => i + 1).map((day) => (
                      <Menu.Item key={day}>
                        {day} {day === 1 ? "Day" : "Days"}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button className="btn-clearfilters">
                  {certExpiryDays} Days
                </Button>
              </Dropdown>
            </div>
          </div>
        </Form>
      </div>

      <div className="notification-page mt-5">
        <div className="notification-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Notification List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
              <button
                className="notification-export-btn"
                onClick={() => setIsExportVisible(true)}
              >
                <CgExport /> Export
              </button>
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={data}
              pagination={{
                pageSize: Math.ceil(data.length / 2),
                total: data.length,
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>
      <ExportModal
        visible={isExportVisible}
        onClose={() => setIsExportVisible(false)}
      />
    </>
  );
};

export default NotificationTable;
